<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="addedUser ? (isEmployerPortal ? ('Admin Added' | translate) : ('User Added' | translate)) : (isEmployerPortal ? ('Add Admin' | translate) : ('Add User' | translate))"
      [canGoBack]="!addedUser"
      [noBow]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <form [formGroup]="form">
    <tidy-wrapper [class]="isRightSideContent ? 'right-side-scroll-enabled' : ''">

      @if (loaded) {
        @if (!addedUser) {
          <tidy-card>
            <tidy-row class="field-top-padding field-bottom-padding">
              <tidy-input
                formControlName="firstName"
                [form]="form.controls.firstName"
                [label]="'First Name'"
                [errorMessage]="'Please enter the first name of the user.'"
                [submitted]="submitted"
                [icon]="'assets/svg/person.svg'" />
            </tidy-row>
            <tidy-row class="field-bottom-padding">
              <tidy-input
                formControlName="lastName"
                [form]="form.controls.lastName"
                [label]="'Last Name'"
                [errorMessage]="'Please enter the last name of the user.'"
                [submitted]="submitted"
                [icon]="'assets/svg/person.svg'" />
            </tidy-row>
            <tidy-row class="field-bottom-padding">
              <tidy-input
                formControlName="email"
                [form]="form.controls.email"
                [label]="'Email'"
                type="email"
                [errorMessage]="'Please enter a valid email.'"
                [submitted]="submitted"
                [icon]="'assets/svg/mail.svg'" />
            </tidy-row>
            <tidy-row>
              <tidy-input
                formControlName="password"
                [form]="form.controls.password"
                [label]="'Password'"
                [errorMessage]="'Please enter a password.'"
                [submitted]="submitted"
                type="password"
                [icon]="'assets/svg/lock-closed.svg'" />
            </tidy-row>
            <tidy-row [align]="'center'" class="extra-bottom-padding">
              <tidy-text
                [helper]="'Share this password with the user and they can change it once they create their account.'" />
            </tidy-row>
            @if (clientInfo?.customer_account?.account_type !== 'regular') {
              <tidy-row>
                <tidy-select
                  [icon]="'assets/svg/information-circle.svg'"
                  [label]="'User Type'"
                  [items]="roleItems"
                  [form]="form.controls.role"
                  formControlName="role"
                  [submitted]="submitted"
                  [errorMessage]="'Please select a user type'" />
              </tidy-row>
            }
            <tidy-row [align]="'center'" [ngClass]="user?.role === 'admin' && form?.value?.role === 'member' ? 'extra-bottom-padding' : ''">
              <tidy-text
                [helper]="'Account admins can see all users and properties. Group managers can only see users and properties on their team.'" />
            </tidy-row>
            @if (form?.value?.role === 'member') {
              @if (teamItems?.length > 0) {
                <tidy-row>
                  <tidy-select
                    [icon]="'assets/svg/location-outline.svg'"
                    [label]="'Add to Group'"
                    [items]="teamItems"
                    [form]="form.controls.team"
                    formControlName="team"
                    [submitted]="submitted"
                    [errorMessage]="'Please select a group'" />
                </tidy-row>
              }
              @if (teamItems?.length == 0) {
                <tidy-row class="extra-top-padding">
                  <tidy-text
                    [header]="'Create Your First Group:'" />
                </tidy-row>
                <tidy-row>
                  <tidy-input
                    formControlName="teamName"
                    [form]="form.controls.teamName"
                    [label]="'Group Name'"
                    [errorMessage]="'Please enter the first name of the group.'"
                    [submitted]="submitted"
                    [icon]="'assets/svg/information-circle.svg'" />
                </tidy-row>
              }
            }
          </tidy-card>
          @if (errorMessage) {
            <tidy-error-message
              [text]="errorMessage" />
          }
          <tidy-button
            [text]="isEmployerPortal ? 'Add Admin' : 'Add User'"
            [action]="boundAddNewUser"
            class="primary" />
          @if (!isEmployerPortal) {
            <tidy-row [align]="'center'">
              <tidy-text
                [header]="isEmployerPortal ? 'Why Add Admins?' : 'Why Add Users?'" />
            </tidy-row>
            @for (card of salesCards; track card) {
              <tidy-alert style="padding: 15px 15px 15px 10px">
                <tidy-grid>
                  <tidy-row>
                    <ion-row>
                      <ion-col size="2" class="vertical-align-center">
                        <div style="margin: auto">
                          <tidy-image
                            [src]="card?.image"
                            style="width:35px" />
                        </div>
                      </ion-col>
                      <ion-col>
                        <tidy-row>
                          <tidy-text
                            [header]="card?.title" />
                        </tidy-row>
                        <tidy-row>
                          <tidy-text
                            [body]="card?.text" />
                          @if (card?.title === 'We Can Help') {
                            <tidy-text
                              [actionBody]="'Book Call'"
                              class="link"
                              (action)="goToBookCall()" />
                          }
                        </tidy-row>
                      </ion-col>
                    </ion-row>
                  </tidy-row>
                </tidy-grid>
              </tidy-alert>
            }
          }
        }
        @if (addedUser) {
          <tidy-row [align]="'center'">
            <tidy-text
              [body]="'Send your password to'" /><span>&nbsp;</span>
              <tidy-text
                [body]="form?.value?.firstName + ' ' + form?.value?.lastName" />
              <tidy-text
                [body]="'. Here is a message you can use:'" />
            </tidy-row>
            <tidy-card>
              <tidy-row [align]="'center'">
                <tidy-text
                  [body]="isEmployerPortal ? 'I added you as an admin in TIDY.' : 'I added you to my account in TIDY.'" />
              </tidy-row>
              <tidy-row [align]="'center'">
                <tidy-text
                  [body]="'Click here to log in: https://www.tidy.com/#/login'" />
              </tidy-row>
              <tidy-row [align]="'center'">
                <tidy-text
                  [body]="'Use this password:'" /><span>&nbsp;</span>
                  <tidy-text
                    [body]="form?.value?.password" />
                </tidy-row>
                <tidy-row [align]="'center'">
                  <tidy-text
                    [body]="'Copy Text'"
                    class="link"
                    (action)="copyText()" />
                  @if (showCopiedText) {
                    <tidy-text
                      [helper]="' Copied'" />
                  }
                </tidy-row>
              </tidy-card>
              <tidy-button
                [text]="'Ok'"
                [action]="boundGoToUsersPage"
                class="primary" />
            }
          }
        </tidy-wrapper>
      </form>
    </ng-template>

    @if (!isRightSideContent) {
      <app-scroll-wrapper [templateContent]="content" />
    }

    @if (isRightSideContent) {
      <ion-content class="ion-content-right-column">
        <ng-container *ngTemplateOutlet="content" />
      </ion-content>
    }
